// 2_components/dklab_compare.js
// dkLab product comparer: places the header icon, then turns the plugin table
// inside Colorbox into a Natios-style comparison grid.

export function init() {
	if (!window.NAT?.media) {
		console.warn("[NAT] dklab_compare.js: window.NAT.media missing — check load order");
		return;
	}

	setupPluginSelectors();
	document.addEventListener("debouncedResize", setupPluginSelectors);
	document.addEventListener("dkLabProductComparerHeaderChanged", onComparerHeaderChanged);
	document.addEventListener("dkLabCompareHeaderIconClicked", onComparerOpened);
	document.addEventListener("click", onDetailCompareClick, true);
	document.addEventListener("dkLabProductComparerHeaderChanged", onHeaderChangedClearLoading);

	if (typeof window.jQuery !== "undefined") {
		window.jQuery(document).on("cbox_complete", onComparerOpened);
		window.jQuery(document).on("cbox_open", clearDetailCompareLoading);
	}

	placeDetailCompare();
	observeDetailCompare();
	observeHeaderIconTarget();
}

function setupPluginSelectors() {
	const selectors = window.dkLabPorovnavacZboziDataLayer?.template?.classic?.selectors;
	if (selectors) {
		selectors.headerIconAddBefore = window.NAT.media.isMobile ? ".top-navigation-contacts-clone" : ".top-navigation-tools";
		selectors.detailAddLinkDivAfter = ".product-top .p-info-wrapper";
	}

	placeHeaderIcon();
	placeDetailCompare();
}

function placeHeaderIcon() {
	const icon = document.querySelector("#dkLabComparerHeaderWrappper");
	if (!icon) {
		return;
	}

	if (window.NAT.media.isMobile) {
		const wrapper = getMenuLinksWrapper();
		if (wrapper && icon.parentElement !== wrapper) {
			wrapper.appendChild(icon);
		}
		return;
	}

	const topNavTools = document.querySelector(".top-navigation-tools");
	if (topNavTools && icon.parentElement !== topNavTools) {
		topNavTools.prepend(icon);
	}
}

function observeHeaderIconTarget() {
	if (document.querySelector(".top-navigation-contacts-clone")) {
		placeHeaderIcon();
		return;
	}

	const observer = new MutationObserver(function () {
		if (document.querySelector(".top-navigation-contacts-clone")) {
			placeHeaderIcon();
			observer.disconnect();
		}
	});
	observer.observe(document.body, { childList: true, subtree: true });
}

function getMenuLinksWrapper() {
	const contactsClone = document.querySelector(".top-navigation-contacts-clone");
	if (!contactsClone || !contactsClone.parentNode) {
		return null;
	}

	let wrapper = document.querySelector(".dklab-header-menu-links");
	if (!wrapper) {
		wrapper = document.createElement("div");
		wrapper.className = "dklab-header-menu-links";
	}
	if (wrapper.nextElementSibling !== contactsClone) {
		contactsClone.parentNode.insertBefore(wrapper, contactsClone);
	}
	return wrapper;
}

function placeDetailCompare() {
	if (!document.body.classList.contains("type-product")) {
		return;
	}

	const compareDiv = document.querySelector("#dkLabComparerDiv") || document.querySelector(".product-top .dkLabComparerDiv");
	const socialButtons = document.querySelector(".product-top .social-buttons-wrapper");
	if (!compareDiv || !socialButtons) {
		return;
	}

	if (compareDiv.parentElement !== socialButtons || socialButtons.firstElementChild !== compareDiv) {
		socialButtons.prepend(compareDiv);
	}

	wrapDetailCompareLabel(compareDiv);
}

function wrapDetailCompareLabel(compareDiv) {
	const compareSpan = compareDiv.querySelector(":scope > span");
	if (!compareSpan || compareSpan.querySelector(":scope > span")) {
		return;
	}

	const label = document.createElement("span");
	while (compareSpan.firstChild) {
		label.appendChild(compareSpan.firstChild);
	}
	compareSpan.appendChild(label);
}

// The plugin replaces the span on click, so the loading state lives on the stable wrapper.
function onDetailCompareClick(event) {
	const wrapper = event.target.closest?.("#dkLabComparerDiv");
	if (wrapper && event.target.closest("#dkLabComparerDetailSpan")) {
		wrapper.classList.add("is-loading");
	}
}

// The header changes right after the click, before the popup opens; only a removal
// (span flips back to "add") means no popup will follow.
function onHeaderChangedClearLoading() {
	if (document.querySelector("#dkLabComparerDetailSpan.dkLabComparerAddProduct")) {
		clearDetailCompareLoading();
	}
}

function clearDetailCompareLoading() {
	document.querySelectorAll("#dkLabComparerDiv.is-loading").forEach(function (wrapper) {
		wrapper.classList.remove("is-loading");
	});
}

function observeDetailCompare() {
	if (!document.body.classList.contains("type-product")) {
		return;
	}

	const productTop = document.querySelector(".product-top");
	if (!productTop) {
		return;
	}

	const observer = new MutationObserver(function () {
		placeDetailCompare();
	});
	observer.observe(productTop, { childList: true, subtree: true });
}

let lastCompareCount = 0;
let compareLoadedFirstTime = true;

function onComparerHeaderChanged() {
	setupPluginSelectors();
	placeDetailCompare();

	const compareInHeader = document.querySelector("#dkLabComparerHeaderWrappper");
	if (!compareInHeader) {
		return;
	}

	const compareSpan = compareInHeader.querySelector("span.dkLabComparerHeaderIconBtn");
	if (!compareSpan) {
		return;
	}

	const em = compareInHeader.querySelector("em");
	const emText = em ? em.textContent : "0";
	compareInHeader.classList.toggle("no-count", !em);

	if (!compareSpan.dataset.natCompareBound) {
		compareSpan.dataset.natCompareBound = "1";
		compareSpan.addEventListener("click", function () {
			document.dispatchEvent(new Event("dkLabCompareHeaderIconClicked"));
		});
	}

	if (emText >= "1" && emText > lastCompareCount && compareLoadedFirstTime === false) {
		compareSpan.click();
	}
	lastCompareCount = emText;
	compareLoadedFirstTime = false;
}

function onComparerOpened() {
	const colorbox = document.querySelector("#colorbox");
	if (!colorbox) {
		return;
	}

	const observer = new MutationObserver(function (_, obs) {
		const tableDiv = document.querySelector("#dkLabComparerTableDiv");
		const table = tableDiv?.querySelector("table#dkLabComparerTable");
		if (!table) {
			return;
		}
		obs.disconnect();
		transformTableToGrid(table, tableDiv);
		bindProductRemoveButtons();
	});

	observer.observe(colorbox, { childList: true, subtree: true });

	const tableDiv = document.querySelector("#dkLabComparerTableDiv");
	const table = tableDiv?.querySelector("table#dkLabComparerTable");
	if (table) {
		observer.disconnect();
		transformTableToGrid(table, tableDiv);
		bindProductRemoveButtons();
	}
}

function bindProductRemoveButtons() {
	document.querySelectorAll(".dkLabComparerImage > span").forEach(function (btn) {
		if (btn.dataset.natCompareBound) {
			return;
		}
		btn.dataset.natCompareBound = "1";
		btn.addEventListener("click", function () {
			const colorbox = document.querySelector("#colorbox");
			if (!colorbox) {
				return;
			}
			const updateObserver = new MutationObserver(function (_, obs) {
				const tableDiv = document.querySelector("#dkLabComparerTableDiv");
				const table = tableDiv?.querySelector("table#dkLabComparerTable");
				if (!table) {
					return;
				}
				obs.disconnect();
				transformTableToGrid(table, tableDiv);
				bindProductRemoveButtons();
			});
			updateObserver.observe(colorbox, { childList: true, subtree: true });
			forwardRemoveClick(btn);
		});
	});
}

// The plugin binds removal on cbox_complete, which (without the elastic animation)
// runs before the grid exists, so grid copies forward to the original table button.
function forwardRemoveClick(btn) {
	if (!btn.closest(".dklab-comparer-grid") || window.jQuery?._data(btn, "events")?.click) {
		return;
	}

	const guid = btn.dataset.dklabCompProductGuid;
	if (!guid) {
		return;
	}

	const original = document.querySelector(`#dkLabComparerTable [data-dklab-comp-product-guid="${CSS.escape(guid)}"]`);
	if (original) {
		original.click();
	}
}

function transformTableToGrid(table, container) {
	if (!table || !container) {
		return;
	}

	const existingGrid = container.querySelector(".dklab-comparer-grid");
	if (existingGrid) {
		existingGrid.remove();
	}
	container.querySelectorAll(".dklab-comparer-control").forEach(function (control) {
		control.remove();
	});

	const rows = Array.from(table.querySelectorAll("tr"));
	if (!rows.length) {
		return;
	}

	const columnCount = rows[0].querySelectorAll("td").length;
	let imageRowIndex = -1;
	let buttonRowIndex = -1;
	rows.forEach(function (row, index) {
		if (row.querySelector(".dkLabComparerImage")) {
			imageRowIndex = index;
		}
		if (row.querySelector("button.btn-cart")) {
			buttonRowIndex = index;
		}
	});

	const gridContainer = document.createElement("div");
	gridContainer.className = "dklab-comparer-grid";

	const firstCol = window.NAT.media.isMobile ? "120px" : "180px";
	const otherCol = window.NAT.media.isMobile ? "180px" : "270px";
	const columns = [firstCol];
	for (let i = 1; i < columnCount; i += 1) {
		columns.push(otherCol);
	}
	gridContainer.style.gridTemplateColumns = columns.join(" ");

	const orderedRows = [];
	if (imageRowIndex !== -1) {
		orderedRows.push(rows[imageRowIndex]);
	}
	rows.forEach(function (row, index) {
		if (index !== imageRowIndex && index !== buttonRowIndex) {
			orderedRows.push(row);
		}
	});

	let priceRowIndex = -1;
	orderedRows.forEach(function (row, index) {
		const hasPrice = Array.from(row.querySelectorAll("td")).some(function (cell) {
			return cell.textContent.trim().match(/\d+\s*(Kč|zł|€|Eur)/);
		});
		if (hasPrice) {
			priceRowIndex = index;
		}
	});

	orderedRows.forEach(function (row, rowIndex) {
		const cells = row.querySelectorAll("td");
		const hasImageCell = Boolean(row.querySelector(".dkLabComparerImage"));
		const hasProductName = Boolean(row.querySelector(".dkLabComparerProductName"));
		const hasPrice = Array.from(cells).some(function (cell) {
			return cell.textContent.trim().match(/\d+\s*(Kč|zł|€|Eur)/);
		});
		const isFirstParameterRow = priceRowIndex !== -1 && rowIndex === priceRowIndex + 1;
		const isLastRow = rowIndex === orderedRows.length - 1;

		cells.forEach(function (cell, cellIndex) {
			const gridItem = document.createElement("div");
			gridItem.className = "dklab-comparer-grid-item";
			gridItem.innerHTML = cell.innerHTML;
			gridItem.querySelectorAll("[data-nat-compare-bound]").forEach(function (el) {
				delete el.dataset.natCompareBound;
			});
			if (cell.className) {
				gridItem.classList.add.apply(gridItem.classList, cell.className.split(" ").filter(Boolean));
			}

			if (cellIndex === 0) {
				gridItem.classList.add("no-bg");
			}
			if (isFirstParameterRow) {
				gridItem.classList.add("first-parameter");
			}
			if (isLastRow) {
				gridItem.classList.add("is-last-row");
			}
			if (hasImageCell && cellIndex === 0) {
				gridItem.classList.add("dkLabComparerImage");
			}
			if (hasProductName) {
				gridItem.classList.add("dklab-comparer-product-name");
			}
			if (cell.textContent.trim().match(/\d+\s*(Kč|zł|€|Eur)/) || (hasPrice && cellIndex === 0)) {
				gridItem.classList.add("dklab-comparer-price");
			}

			if (hasImageCell && buttonRowIndex !== -1 && cellIndex !== 0) {
				const buttonCell = rows[buttonRowIndex].querySelectorAll("td")[cellIndex];
				const originalBtn = buttonCell?.querySelector("button.btn-cart");
				if (originalBtn) {
					const clonedBtn = originalBtn.cloneNode(true);
					clonedBtn.addEventListener("click", function (e) {
						e.preventDefault();
						originalBtn.click();
					});
					gridItem.appendChild(clonedBtn);
				}
			}

			gridContainer.appendChild(gridItem);
		});
	});

	table.style.display = "none";
	container.appendChild(gridContainer);
	addScrollControls(container);
}

function addScrollControls(container) {
	if (container.scrollWidth <= container.clientWidth + 1) {
		return;
	}

	const controlLeft = document.createElement("div");
	controlLeft.className = "dklab-comparer-control left";
	const controlRight = document.createElement("div");
	controlRight.className = "dklab-comparer-control right";

	function updateControls() {
		const scrollLeft = container.scrollLeft;
		const maxScroll = container.scrollWidth - container.clientWidth;
		if (scrollLeft > 0) {
			controlLeft.style.opacity = "1";
			controlLeft.style.pointerEvents = "auto";
		} else {
			controlLeft.style.opacity = "0";
			controlLeft.style.pointerEvents = "none";
		}
		if (scrollLeft < maxScroll - 1) {
			controlRight.style.opacity = "1";
			controlRight.style.pointerEvents = "auto";
		} else {
			controlRight.style.opacity = "0";
			controlRight.style.pointerEvents = "none";
		}
	}

	controlLeft.addEventListener("click", function () {
		container.scrollBy({ left: -270, behavior: "smooth" });
	});
	controlRight.addEventListener("click", function () {
		container.scrollBy({ left: 270, behavior: "smooth" });
	});
	container.addEventListener("scroll", updateControls);
	container.appendChild(controlLeft);
	container.appendChild(controlRight);
	updateControls();
}
